module.exports = __webpack_public_path__ + "static/media/carousel_quienes_somos_2.3fc601e6.jpg";